import React from 'react';
import { Router } from 'react-router-dom';
import { useLocale } from 'useLocale';
import MeContextProvider from 'modules/me/MeContextProvider';
import { MeLocaleIntlProvider } from 'modules/intl';
import { UIContextProvider } from 'modules/common/hooks/useUIContext';
import ConnectorSelectionContextProvider from 'modules/Connectors/contexts/ConnectorSelectionContextProvide';
import RepliconNavigationProvider from 'modules/common/hooks/RepliconNavigationProvider';
import Theme from '../../Theme';
import { Routes, AdminRoutes } from '../common';
import '../../index.css';
import { browserHistory } from '../../browser-history';
import { SidePanelContextProvider } from '../rootPage';
import PageLayoutContainer from './PageLayoutContainer';

function App(): JSX.Element {
  const locale = useLocale();

  return (
    <Theme direction={locale.direction}>
      <MeLocaleIntlProvider>
        <MeContextProvider>
          <UIContextProvider>
            <RepliconNavigationProvider>
              <PageLayoutContainer>
                <ConnectorSelectionContextProvider>
                  <Router history={browserHistory}>
                    <SidePanelContextProvider>
                      <Routes />
                      <AdminRoutes />
                    </SidePanelContextProvider>
                  </Router>
                </ConnectorSelectionContextProvider>
              </PageLayoutContainer>
            </RepliconNavigationProvider>
          </UIContextProvider>
        </MeContextProvider>
      </MeLocaleIntlProvider>
    </Theme>
  );
}

export default App;
